import Vue, { CreateElement } from '@src/vue'

import { Component, Prop } from 'vue-property-decorator'

import { Icon } from '@src/elements/icon/icon'

import './loader.sass'

@Component
export class Loader extends Vue {

  @Prop({ required: false })
  loading: boolean | undefined

  @Prop({ required: false, default: 'black' })
  color: 'string'

  render (h: CreateElement) {
    return this.loading !== false ? <div class='loader' color={this.color}>
      <Icon name='../img/loader' />
    </div> : null
  }
}
